<template>
  <select v-model="selected">
    <option></option>
    <option
      v-for="subject of subjects"
      :value="subject"
      :key="subject.code">
        {{ subject.name }}
    </option>
  </select>
</template>

<script lang="ts">
import { Subject } from '@/store/master/types'
import { RootState } from '@/store/types'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SubjectInput extends Vue {
  @Prop() value!: Subject

  created() {
    this.$store.dispatch('fetchMasterSubjects')
  }

  private get subjects(): Subject[] {
    return (this.$store.state as RootState).master.subjects
  }

  private get selected(): Subject {
    return this.value
  }

  private set selected(subject: Subject) {
    this.$emit('input', subject || null)
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
